import type { ReactNode } from 'react';

export function FilterBar(props: {
  label: string;
  children: ReactNode;
  actions?: ReactNode;
}): ReactNode {
  return (
    <search
      aria-label={props.label}
      className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between"
    >
      <div className="flex flex-wrap items-end gap-3">{props.children}</div>
      {props.actions !== undefined && (
        <div className="flex shrink-0 items-center gap-2">{props.actions}</div>
      )}
    </search>
  );
}
